<template>
	<div class="row mt-5 pt-1">
		<b-button :class="currentStep === 1 ? 'selected' : ''" class="progress-item col-6" style="z-index: 2;">
			<div class="progress-item-title1">
				<img v-if="currentStep > 1" class="checkmark" src="@/assets/checkmark.svg" />
				1. Summary
			</div>
			<div class="progress-arrow"></div>
		</b-button>
		<b-button :class="currentStep > 1 ? 'selected' : ''" class="progress-item col-6" style="z-index: 1;">
			<div class="progress-item-titles">
			2. Details
			</div>
		</b-button>
	</div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: ['currentStep']
}
</script>

<style lang="scss" scoped>
	.progress-item {
		height: 50px;
		color: $mid-grey-2;
		font-family: $primary-text-font;
		font-size: 13px;
		font-weight: 500;
		letter-spacing: 1px;
		text-transform: uppercase;
		text-overflow: ellipsis;
		border: solid 1px $light-grey-1;
		background-color: $light-grey-2;
		cursor: default !important;
		display: flex;
		white-space: nowrap;
		
		&:hover, &:active, &:focus {
    color: $mid-grey-2 !important;
    border: solid 1px $light-grey-1 !important;
    background-color: $light-grey-2 !important;
    box-shadow: none !important;
  }
}

.selected {
  color: $harrods-medium-green !important;
  border: solid 1px $light-grey-4 !important;
  background-color: $harrods-white !important;

  &:hover,
  &:active,
  &:focus {
    color: $harrods-medium-green !important;
    border: solid 1px $light-grey-4 !important;
    background-color: $harrods-white !important;
  }
}

.completed {
  color: $mid-grey-2 !important;
  border: solid 1px $light-grey-1 !important;
  background-color: $harrods-white !important;

  &:hover,
  &:active,
  &:focus {
    color: $mid-grey-2 !important;
    border: solid 1px $light-grey-1 !important;
    background-color: $harrods-white !important;
  }
}


.progress-arrow {
	content:"";
	margin-left:5px;
	margin-top:0;
	margin-right:-10px;
	width:31px;
	height:31px;
	float:right;
	background-color:inherit;
	transform:translate(6.5px,8.5px) rotate(45deg) skew(8deg,8deg);
	top:0;
	right:0;
	position:absolute;
	border-color:#d8d8d8;
	border-style:solid solid none none;
	border-width:1px;
}

.progress-item-title1 {
	overflow: hidden;
	display: flex;
}

.progress-item-titles {
	overflow: hidden;
	padding-left: 14px;
}
	
.checkmark {
	display: flex;
	height: 28px;
	width: 28px;
	padding-right: 10px;
	transform: translate(0px,-5px);
}

</style>